export default __webpack_public_path__ + "static/homeHeroTexture-2447e8afa5bcfc0587a791315d8b6745.svg";